<template>
  <div>
    <div :id="id" :option="option" :style="height>0?`height: ${height}px`:''"/>
  </div>
</template>

<script>
import HighCharts from 'highcharts'
import loadExport from 'highcharts/modules/exporting'
import sunburst from 'highcharts/modules/sunburst'

export default {
  name: 'GraphicsChart',
  // 验证类型
  props: {
    id: {
      type: String
    },
    option: {
      type: Object
    },
    height: {
      type: Number,
      default: 0
    }
  },
  watch: {
    option() {
      HighCharts.chart(this.id, this.option)
    }
  },
  mounted() {
    HighCharts.chart(this.id, this.option)
    loadExport(HighCharts)
    sunburst(HighCharts)
  }
}
</script>

<style scoped>

</style>
